import { AccordionDrivingLicenseBookletForm as AccordionDrivingLicenseBookletFormVM } from 'shell/view-models/accordion-driving-license-booklet-form';
import { Vehicle } from 'shell/models/person/vehicle-type';

export const transformDrivingLicenseBooklet = (
  values: AccordionDrivingLicenseBookletFormVM | undefined
): Vehicle | undefined => {
  const result = values
    ? {
        possessoAutoveicoli: values?.motorVehicles || '',
        possessoPatente: values?.drivingLicense || '',
      }
    : undefined;

  return result;
};
